import Loading from "shared/components/Spin";
import { TEMPLATES, TEMPLATE_TYPES } from "utils/constants";
import CollectionNeeds from "../CosaeTer/CollectionNeeds";
import Comparison from "../CosaeTer/Comparison";
import Contact from "../CosaeTer/Contact";
import Contract from "../CosaeTer/Contract";
import Default from "../CosaeTer/Default";
import Fast from "../CosaeTer/Fast";
import Product from "../CosaeTer/Product";
import Quote from "../CosaeTer/Quote";
import SelectProducts from "../CosaeTer/SelectProducts";

const Templates = {
  Loading: Loading,
  [TEMPLATES.B2B.THEMES[TEMPLATE_TYPES.B2B_RADIANCE_COSA].CONTACT]: Contact,
  [TEMPLATES.B2B.THEMES[TEMPLATE_TYPES.B2B_RADIANCE_COSA].CONTRACT]: Contract,
  [TEMPLATES.B2B.THEMES[TEMPLATE_TYPES.B2B_RADIANCE_COSA].QUOTE]: Quote,
  [TEMPLATES.B2B.THEMES[TEMPLATE_TYPES.B2B_RADIANCE_COSA].FAST]: Fast,
  [TEMPLATES.B2B.THEMES[TEMPLATE_TYPES.B2B_RADIANCE_COSA].COLLECTION_NEEDS]:
    CollectionNeeds,
  [TEMPLATES.B2B.THEMES[TEMPLATE_TYPES.B2B_RADIANCE_COSA].SELECT_PRODUCTS]:
    SelectProducts,
  [TEMPLATES.B2B.THEMES[TEMPLATE_TYPES.B2B_RADIANCE_COSA].COMPARISON]:
    Comparison,
  ...Product,
  default: Default,
};
export default Templates;
